/**
 * WorkflowIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const WorkflowIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m13.4 5.5-.4-2H5V3a1 1 0 0 0-2 0v19h2v-8.5h5.6l.4 2h10v-10z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const WorkflowIcon = makeIcon('WorkflowIcon', WorkflowIconSvg)
